import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'

import PDComponent from '../../pd-component'

export const List = ({regions = [], listType = 'unordered'}) => {
    const components = regions.flatMap((region) => region.components || [])

    if (!components.length) {
        return null
    }

    const listElement = listType === 'ordered' ? 'ol' : 'ul'

    return (
        <Box className="list-component">
            <Box
                as={listElement}
                listStyleType={listType === 'ordered' ? 'decimal' : 'disc'}
                paddingLeft={{base: '20px', lg: '40px'}}
                color="black.100"
            >
                {components.map((component, index) => (
                    <PDComponent
                        key={`${component.id || 'list-item'}-${index}`}
                        component={component}
                        elementType="li"
                    />
                ))}
            </Box>
        </Box>
    )
}

List.propTypes = {
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            components: PropTypes.arrayOf(PropTypes.object)
        })
    ),
    listType: PropTypes.oneOf(['ordered', 'unordered'])
}

export default List
